document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("whatsappPopup");
  const openBtn = document.getElementById("openPopup");
  const closeBtn = document.getElementById("closePopup");
  const form = document.getElementById("whatsappForm");
  const popupBox = popup.querySelector(".popup-box");

  openBtn.addEventListener("click", () => {
    popup.style.display = "flex";

    /* Lazy-load background image ONLY when opened */
    if (!popupBox.style.backgroundImage) {
      popupBox.style.backgroundImage =
        "url(https://collabo.digital/wp-content/uploads/2024/09/hero-bg-home-3.png)";
      popupBox.style.backgroundSize = "cover";
      popupBox.style.backgroundPosition = "center";
    }
  });

  closeBtn.addEventListener("click", () => {
    popup.style.display = "none";
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) popup.style.display = "none";
  });

  form.addEventListener("submit", function(e) {
    e.preventDefault();

    const name = document.getElementById("name").value;
    const phone = document.getElementById("phone").value;
    const message = document.getElementById("message").value;

    const whatsappNumber = "917306296724";
    const text = `Hello,%0AName: ${name}%0APhone: ${phone}%0AMessage: ${message}`;

    window.open(`https://wa.me/${whatsappNumber}?text=${text}`, "_blank");

    form.reset();
    popup.style.display = "none";
  });
});
